export default __webpack_public_path__ + "static/media/5-BorbjergSparekasse.76c28cf8.png";